import { FieldTypeEnum } from './field-type.enum';
import { MatTableInputTypeEnum } from './mat-table-input-type.enum';
import { MatTableIconTypeEnum } from './mat-table-icon-type.enum';
import { AlignTypeEnum } from './align-type.enum';

export class MatTableColumnModel {
  // Specify the field to display
  public field: string;

  // If the field is an object, specify the sub field of the object to display
  public subField: string;

  // If the sub field is an object, specify the sub sub field of the object to display
  public subSubField: string;

  // If the sub sub field is an object, specify the sub sub sub field of the object to display
  public subSubSubField: string;

  // The label is a trad KEY which will be display in the header
  public label: string;

  // The object type determine the type of the field
  public fieldType: FieldTypeEnum;

  // The input type of the field
  public inputType: MatTableInputTypeEnum;

  // the flex grow value of the column
  public columnFlexGrow = 1;

  // To use the currency pipe the object passed in parameters must contain a field currencyCode!!!
  public currencyType = false;

  // Suggestions displayed for the auto complete field
  public suggestions: any[];

  // the fieldToDisplay is the name of the field to display for the suggestions (ex: companyOrPersonName for SupplierModel)
  public fieldToDisplay;

  // the fieldToDisplayDetails is the name of the field to display details (used for display rights details on tooltip)
  public fieldToDisplayDetails;

  // This is where the select values are saved
  public selectValues: any[];

  // Field used when each select needs a different list of suggestions
  public listOfListOfSelectValues: any[][] = [];


  public iconType = false;
  public iconTemplate: MatTableIconTypeEnum;

  // for simple autocomplete
  public filteredList: any;
  public decimalNumber: number;

  // for date
  public dateFormat: string;
  public dateFormatLegal: string;

  public maxLength: number;
  public pattern: string;

  public textAlign: AlignTypeEnum;

  // for custom column
  public justifyContentCenter = false;

  public filterValue = '';
  public withFilter = false;
  public isListFilter = false;

  public htmlTemplate;

  constructor(field: string, label: string, fieldType: FieldTypeEnum, inputType: MatTableInputTypeEnum) {
    this.field = field;
    this.label = label;
    this.fieldType = fieldType;
    this.inputType = inputType;
    this.textAlign = AlignTypeEnum.LEFT;
    this.filterValue = '';
  }

}
